import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaBookOpen,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BrandStorytellingVideoServicesInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Brand Storytelling Video Services in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Connect Through Story</Subheading>}
        heading={
          <Heading>
            Brand Storytelling <span tw="text-primary-500">Video Services</span>{" "}
            in Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in brand storytelling video
            services in **Bur Dubai**, crafting emotionally engaging narratives
            that connect your brand with audiences and build lasting loyalty.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1578269174936-2709b6aeb913?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=800&auto=format&fit=crop",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Tell Your Brand Story"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Impactful Brand Storytelling in Bur Dubai"
        description="We create videos that resonate and inspire."
        cards={[
          {
            icon: <FaBookOpen color="#ff5464" size={40} />,
            title: "Compelling Narratives",
            description: "Stories that capture your brand’s essence.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "Visually stunning videos with emotional depth.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Timely Delivery",
            description: "Fast production to meet your campaign needs.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Optimized",
            description: "Tailored for social media, websites, and ads.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Brands",
            description: "Bur Dubai’s choice for storytelling videos.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Videos for campaigns, origins, or values.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Brand Storytelling Process"
        description={
          <Description>
            We craft meaningful brand videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Discover your brand’s story and goals.</li>
              <li>Scripting: Develop a narrative that resonates.</li>
              <li>Filming: Capture visuals to bring your story to life.</li>
              <li>Editing: Enhance with music, effects, and branding.</li>
              <li>Delivery: Provide videos ready to captivate audiences.</li>
              <li>Support: Offer revisions to perfect your vision.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1531547255897-f400dc1b7de2?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1579566346927-c68383817a25?q=80&w=800&auto=format&fit=crop",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Brand Storytelling Wins in Bur Dubai"
        description="Our videos have built stronger connections."
        cards={[
          {
            icon: <FaBookOpen color="#ff5464" size={40} />,
            title: "Audience Engagement",
            description: "Stories that sparked brand loyalty.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "96% satisfaction from Bur Dubai brands.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Increased Reach",
            description: "Videos shared widely across platforms.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Share Your Story?</Subheading>}
        heading="Brand Storytelling Video Services in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert brand storytelling video
            services in Bur Dubai. Get narrative-driven videos to elevate your
            brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1494441822675-7ce8f87ec18a?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=800&auto=format&fit=crop",
          "https://images.unsplash.com/photo-1559030623-0226b1241edd?q=80&w=800&auto=format&fit=crop",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
